<template>
  <!--<f7-block-title>{{ $t('AverageSMSUsage') }}</f7-block-title>-->
  <div class="card margin-bottom overflow-visible">
    <div class="card-header">{{ $t('AverageSMSUsage') }}</div>
    <div class="card-content height-180 display-flex align-items-center">
      <v-chart
          class="chart overflow-visible"
          ref="chart"
          :option="chartOption"
          :loading="isLoading"
      />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {h} from 'vue';
import { createComponent } from 'echarts-for-vue';
import {mapGetters} from "vuex";
import {getDaysInMonth} from "../../../js/helpers";


export default {
  name: "dashboard-sms-usage",

  components: {
    'v-chart': createComponent({ echarts, h }),   // use as a component
  },

  data () {
    let date = new Date()
    return {
      isLoading: true,
      chartOption: {},
      daysInMonth: getDaysInMonth(date.getFullYear(), date.getMonth()),
      daysInWeek: 7
    }
  },

  computed: {
    ...mapGetters(['UsageOverview']),
  },

  watch: {
    UsageOverview(data){
      this.chartOption = {
        color: ['#80cc7e', '#ffcf52'],
        grid: {
          left: 35,
          top: 45,
          right: 15,
          bottom: 30
        },
        legend: {},
        tooltip: {
          /*formatter: function (params){
            console.log(params)
            return params.value
          }*/
        },
        dataset: {
          dimensions: ['label', 'Sent', 'Received'],
          source: [
            {label: this.$t('Today'), Sent: data.SMS_MT_DAY, Received: data.SMS_MO_DAY},
            {label: this.$t('AvgWk'), Sent: data.SMS_MT_WEEK ? parseFloat(data.SMS_MT_WEEK / this.daysInWeek).toFixed(1) : 0, Received: data.SMS_MO_WEEK ? parseFloat(data.SMS_MO_WEEK / this.daysInWeek).toFixed(1) : 0},
            {label: this.$t('AvgMth'), Sent: data.SMS_MT_MONTH ? parseFloat(data.SMS_MT_MONTH / this.daysInMonth).toFixed(1) : 0, Received: data.SMS_MO_MONTH ? parseFloat(data.SMS_MO_MONTH / this.daysInMonth).toFixed(1) : 0 },
          ]
        },
        xAxis: {type: 'category'},
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {type: 'bar', barGap: '15%'},
          {type: 'bar', barGap: '15%'},
        ]
      }
      this.isLoading = false
    }
  },

  mounted() {


  },

  unmounted() {
    console.log('unmoundet')
    this.$refs?.chart?.inst.dispose()
  }
}
</script>
